let textImgElements = document.querySelectorAll('.h-text-img')
const icons = document.querySelectorAll('.icon')
const featureItems = document.querySelectorAll('.feature')

const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('in-view')
        }
    });
});

const observerDelay = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {

            setTimeout(function () {
                entry.target.classList.add('in-view')
            }, 1500);
        }
    });
});

const observerDelaySmall = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {

            setTimeout(function () {
                entry.target.classList.add('in-view')
            }, 500);
        }
    });
});

textImgElements.forEach(obs => {
    observer.observe(obs);
});

icons.forEach(obs => {
    observerDelaySmall.observe(obs);
});

featureItems.forEach(obs => {
    observerDelay.observe(obs);
});



const menuBtn = document.querySelector('.s-menu-btn')
const mobileMenu = document.querySelector('.menu-container')
const mobileMenuContainer = document.querySelector('.mobile-header')
const body = document.querySelector('body')
const menuItems = document.querySelectorAll('.menu-item')
const cog = document.querySelector('.element-3-cogg')


menuBtn.addEventListener('click', function () {
    mobileMenu.classList.toggle('open')
    menuBtn.classList.toggle('open')
    body.classList.toggle('open')
})

menuItems.forEach(function (e) {
    e.addEventListener('click', function () {
        mobileMenu.classList.toggle('open')
        menuBtn.classList.toggle('open')
        body.classList.toggle('open')
    })
})






